import { render, staticRenderFns } from "./OrderMobileCard.vue?vue&type=template&id=790a3e8f&scoped=true"
import script from "./OrderMobileCard.vue?vue&type=script&lang=js"
export * from "./OrderMobileCard.vue?vue&type=script&lang=js"
import style0 from "./OrderMobileCard.vue?vue&type=style&index=0&id=790a3e8f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "790a3e8f",
  null
  
)

export default component.exports